export default {
  home: {
    'deviceSum': 'cihazToplamı',
    'onlineDevice': 'çevrimiçiCihaz',
    'alarmQuantity': 'alarmSayısı',
    'offDevice': 'kapatCihazı',
    'deviceList': 'cihazListe',
    'map': 'harita',
    'deviceInfo': 'cihazBilgi',
    'deviceName': 'cihazAdı',
    'groupId': 'grupKimliği',
    'onlineState': 'çevrimiçiDurum',
    'deviceOffTime': 'cihazKapalıZamanı',
    'deviceOnlineTime': 'cihazÇevrimiçiZamanı',
    'createTime': 'oluşturmaZamanı',
    'featureInfo': 'öğeBilgi',
    'noData': 'yokVeri',
    'groupNoDevice': 'grupYokCihaz',
    'offLine': 'çevrimdışı',
    'onLine': 'çevrimiçi',
    'Device sum': 'Cihaz toplamı',
    'Online device': 'Çevrimiçi cihaz',
    'Alarm quantity': 'Alarm sayısı',
    'Off device': 'Cihazı kapat',
    'Device list': 'Cihaz listesi',
    'Device information': 'Cihaz bilgisi',
    'Device name': 'Cihaz adı',
    'Group id': 'Grup kimliği',
    'Online state': 'Çevrimiçi durum',
    'Device off time': 'Cihaz kapalı zamanı',
    'Device online time': 'Cihaz çevrimiçi zamanı',
    'CreateTime': 'Cihaz Oluşturma Zamanı',
    'Information element': 'Bilgi öğesi',
    'No data': 'Veri yok',
    'The current group has no device': 'Geçerli grubun cihazı yok',
    'Off line': 'Çevrimdışı',
    'On line': 'Çevrimiçi'
  },
  arg: {
    'closeDialog': 'kapatDiyaloğu',
    'viewCurve': 'görüntüleEğriyi',
    'historicalData': 'geçmişVeriler',
    'query': 'sorgu',
    'exportData': 'dışaaktarVerileri',
    'noTime': 'yokZaman',
    'noAtr': 'Özellik boş olamaz',
    'Are you sure it\'s off?': 'Kapalı olduğundan emin misiniz?',
    'View curve': 'Eğriyi görüntüle',
    'Historical data': 'Geçmiş veriler',
    'Query': 'Sorgu',
    'Export data': 'Verileri dışa aktar',
    'The start time and end time cannot be empty': 'Başlangıç '
  },
  group: {
    'defaultGroup': 'varsayılanGrup',
    'groupList': 'grupListe',
    'inputGroupName': 'girGrupAdı',
    'selectGroupState': 'seçGrupDurum',
    'inputDeviceName': 'girCihazAdı',
    'editSuccess': 'düzenleBaşarılı',
    'editFail': 'düzenleBaşarısız',
    'confirmSubmission': 'onaylaGönderimi',
    'tip': 'ipucu',
    'confirm': 'onayla',
    'cancel': 'iptal',
    'addSuccess': 'ekleBaşarılı',
    'addFail': 'ekleBaşarısız',
    'sureDeleteScene': 'eminSilSahne',
    'successDelete': 'başarıSil',
    'undelete': 'silmeyigerial',
    'search': 'ara',
    'newScene': 'yeniSahne',
    'edit': 'düzenle',
    'sceneName': 'sahneAdı',
    'sceneState': 'sahneDurumu',
    'usable': 'kullanılabilir',
    'forbidden': 'yasak',
    'submit': 'gönder',
    'Default group': 'Varsayılan grup',
    'Scene list': 'Sahne listesi',
    'Please enter a scene name': 'Lütfen bir sahne adı girin',
    'Please select the scene state': 'Lütfen sahne durumunu seçin',
    'Please enter the device name': 'Lütfen cihaz adını girin',
    'Edit successfully': 'Başarılı bir şekilde düzenle',
    'Edit failure': 'Düzenleme başarısız',
    'Do you confirm submission?': 'Gönderimi onaylıyor musunuz?',
    'Tip': 'İpucu',
    'Confirm': 'Onayla',
    'Cancel': 'İptal',
    'Add successfully': 'Başarılı bir şekilde ekle',
    'Add failure': 'Ekle başarısız',
    'Are you sure to delete the current scene?': 'Geçerli sahneyi silmek istediğinizden emin misiniz?',
    'Successfully delete': 'Başarılı bir şekilde silindi',
    'Undelete': 'Silmeyi geri al',
    'Search': 'Ara',
    'New scene': 'Yeni sahne',
    'Edit': 'Düzenle',
    'Scene name': 'Sahne adı',
    'Scene state': 'Sahne durumu',
    'Usable': 'Kullanılabilir',
    'Forbidden': 'Yasak',
    'Submit': 'Gönder'
  },
  device: {
    'noteNameTip': 'notAdıİpucu',
    'noteName': 'notAdı',
    'devicename': 'cihazadı',
    'homeGroup': 'evGrubu',
    'longitude': 'boylam',
    'latitude': 'enlem',
    'deviceNameSearch': 'cihazAdıArama',
    'equipmentInformation': 'ekipmanBilgileri',
    'ProductOwnership': 'ÜrünSahipliği',
    'creationTime': 'oluşturmaZamanı',
    'operation': 'işlem',
    'Please fill in the remark name': 'Lütfen açıklama adını girin',
    'Note Name': 'Not Adı',
    'Device name': 'Cihaz adı',
    'Home group': 'Ev grubu',
    'Longitude': 'Boylam',
    'Latitude': 'Enlem',
    'Please enter the device name to search': 'Lütfen aramak için cihaz adını girin',
    'Equipment information': 'Ekipman bilgisi',
    'Product of ownership': 'Sahip olunan ürün',
    'creation time': 'oluşturma zamanı',
    'Operation': 'İşlem'
  },
  alarm: {
    'runningStatus': 'çalışanDurum',
    'close': 'kapat',
    'open': 'aç',
    'handleOpen': 'işlemAçık',
    'passageway': 'geçişyolu',
    'selectPassageway': 'seçGeçişyolu',
    'alarmRule': 'alarmKuralı',
    'searchTitle': 'araBaşlık',
    'add': 'ekle',
    'edit': 'düzenle',
    'triggerType': 'tetikleyiciTürü',
    'attributeChange': 'öznitelikDeğişikliği',
    'deviceOffLine': 'cihazÇevrimdışı',
    'hitCount': 'isabetSayısı',
    'duration': 'süre',
    'alarmCondition': 'alarmKoşulu',
    'notRelease': 'yayınlanmadı',
    'haveReleased': 'yayınlandı',
    'soldOut': 'tükendi',
    'alarmName': 'alarmAdı',
    'selectDevice': 'seçCihaz',
    'conditionList': 'koşulListesi',
    'and&or': 've&ya da',
    'attribute': 'öznitelik',
    'selectCondition': 'seçKoşul',
    'delete': 'sil',
    'enterContent': 'girİçerik',
    'addCondition': 'ekleKoşul',
    'alarmLevel': 'alarmSeviyesi',
    'notificationChannel': 'bildirimKanalı',
    'advancedOptions': 'gelişmişSeçenekler',
    'manuallyAlarm': 'manuelolarakAlarm',
    'selectManually': 'seçManuelolarak',
    'startTime': 'başlangıçSaat',
    'endTime': 'bitişSaat',
    'effectivePeriod': 'etkinlikSüresi',
    'noTimeSelect': 'yokZamanSeçimi',
    'experienceTime': 'deneyimZamanı',
    'returnTime': 'dönüşZamanı',
    'support': 'destek',
    'nonsupport': 'desteksiz',
    'notificationPeriod': 'bildirimSüresi',
    'general': 'genel',
    'significance': 'önem',
    'seriousness': 'ciddiyet',
    'minute': 'dakika',
    'second': 'saniye',
    'time': 'zaman',
    'alarmNameNot': 'alarmAdıYok',
    'sourceTypeNot': 'kaynakTürüYok',
    'sourceNot': 'kaynakYok',
    'triggerTypeNot': 'tetikleyiciTürüYok',
    'conditionsNot': 'koşullarYok',
    'severityNot': 'şiddetYok',
    'manuallyNot': 'manuelolarakYok',
    'success': 'başarı',
    'fail': 'başarısız',
    'and': 've',
    'or': 'ya da',
    'greaterThan': 'büyüktür',
    'equalOrGreater': 'eşitYadaBüyük',
    'lessThan': 'küçüktür',
    'lessEqual': 'küçükEşit',
    'equalTo': 'eşit',
    'unequalTo': 'eşitDeğil',
    'selectActiveDevice': 'seçEtkinCihazı',
    'running status': 'çalışan durum',
    'stop': 'durdur',
    'running': 'çalışıyor',
    'Notification channel': 'Bildirim kanalı',
    'Please select a notification channel': 'Lütfen bir bildirim kanalı seçin',
    'Alarm rule': 'Alarm kuralı',
    'Enter the alarm title to search for alarms': 'Alarmları aramak için alarm başlığını girin',
    'Added': 'Eklendi',
    'Edit': 'Düzenle',
    'Trigger type': 'Tetikleyici türü',
    'Device attribute change': 'Cihaz öznitelik değişikliği',
    'Device offline': 'Cihaz çevrimdışı',
    'Hit count': 'İsabet sayısı',
    'Duration': 'Süre',
    'Alarm condition': 'Alarm koşulu',
    'Not release': 'Yayınlanmadı',
    'Have released': 'Yayınlandı',
    'Sold out': 'Tükendi',
    'Alarm name': 'Alarm adı',
    'Please select an active device': 'Lütfen etkin bir cihaz seçin',
    'Condition list': 'Koşul listesi',
    'Please select and, or': 'Lütfen ve, ya da seçiniz',
    'Attribute': 'Öznitelik',
    'Please select a condition': 'Lütfen bir koşul seçin',
    'Please enter content': 'Lütfen içerik girin',
    'Add condition': 'Koşul ekle',
    'Alarm level': 'Alarm seviyesi',
    'Advanced options': 'Gelişmiş seçenekler',
    'Manually clear an alarm': 'Bir alarmı manuel olarak temizle',
    'Select manually clear the alarm': 'Alarmı manuel olarak temizlemeyi seçin',
    'Start time': 'Başlangıç ',
    'End time': 'Bitiş saati',
    'Effective period': 'Etkinlik süresi',
    'No time period is selected': 'Zaman aralığı seçilmedi',
    'To experience custom timing (notifications are more flexible)': 'Özel zamanlamayı deneyimlemek için (bildirimler daha esnektir)',
    'Return to the traditional time interval Settings': 'Geleneksel zaman aralığına geri dön Ayarlar',
    'Support': 'Destek',
    'Nonsupport': 'Desteklenmiyor',
    'Notification period': 'Bildirim süresi',
    'General': 'Genel',
    'Significance': 'Önem',
    'Seriousness': 'Ciddilik',
    'The alarm name cannot be empty': 'Alarm adı boş olamaz',
    'The data source type cannot be empty': 'Veri kaynağı türü boş olamaz',
    'The device source cannot be empty': 'Cihaz kaynağı boş olamaz boş',
    'The trigger type cannot be empty': 'Tetikleyici türü boş olamaz',
    'The list of conditions cannot be empty': 'Koşullar listesi boş olamaz',
    'The alarm severity cannot be empty': 'Alarm şiddeti boş olamaz',
    'Manually clear the alarm. The value cannot be empty': 'Alarmı manuel olarak temizle. Değer boş olamaz',
    'Success': 'Başarılı',
    'Fail': 'Başarısız',
    'And': 'Ve',
    'Or': 'Ya da',
    'Greater Than': 'Büyüktür',
    'Be equal or greater than': 'Eşit ya da daha büyük',
    'Less than': 'Küçüktür',
    'Less than or equal to': 'Daha küçük ya da eşit',
    'Equal to': 'Eşittir',
    'unequal to': 'Eşit değildir'
  },
  inform: {
    'warningMessage': 'uyarıMesajı',
    'pending': 'bekliyor',
    'automaticResolution': 'otomatikÇözüm',
    'manualSolution': 'manuelÇözüm',
    'Warning message': 'Uyarı mesajı',
    'Automatic resolution': 'Otomatik çözüm',
    'Manual solution': 'Manuel çözüm'
  },
  notification: {
    'notificationChannelName': 'bildirimKanalıAdı',
    'notificationWay': 'bildirimYolu',
    'sureDelete': 'eminSil',
    'emailEmpty': 'emailBoş',
    'emailFormat': 'emailBiçimi',
    'nameEmpty': 'isimBoş',
    'typeEmpty': 'türBoş',
    'updateSuccessfully': 'güncellemeBaşarılı',
    'createdSuccessfully': 'oluşturulduBaşarılı',
    'email': 'email',
    'emailAddress': 'emailAdres',
    'phoneMessage': 'Cep telefonu numarası',
    'invalidPhoneMessage': 'Geçersiz telefon numarası',
    'Notification channel name': 'Bildirim kanalı adı',
    'the way of notification': 'bildirim yolu',
    'Are you sure to delete it?': 'Silmek istediğinizden emin misiniz?',
    'The email address cannot be empty': 'E-posta adresi boş olamaz',
    'The email address format is incorrect': 'E-posta adresi biçimi yanlış',
    'The notification name cannot be empty': 'Bildirim adı boş olamaz',
    'The notification type cannot be empty': 'Bildirim türü boş olamaz',
    'update successfully': 'güncelleme başarılı',
    'Created successfully': 'Başarıyla oluşturuldu',
    'mailbox': 'posta kutusu',
    'e-mail address': 'e-posta adresi'
  },
  profile: {
    'enterNickname': 'girTakmaAd',
    'enterEmail': 'girEmail',
    'validEmail': 'geçerliEmail',
    'enterNumber': 'girNumara',
    'enterValidNumber': 'girGeçerliNumara',
    'modifySuccessfully': 'değiştirBaşarıyla',
    'failModify': 'başarısızDeğiştirme',
    'enterOldPassword': 'girEskiŞifre',
    'enterNewPassword': 'girYeniŞifre',
    'characters': 'karakterler',
    'confirmNewPassword': 'onaylaYeniŞifre',
    'twoPasswordsDifferent': 'ikiŞifreFarklı',
    'passwordSuccessfully': 'şifreBaşarıyla',
    'essentialInformation': 'temelBilgiler',
    'failedPassword': 'başarısızŞifre',
    'nickname': 'TakmaAd',
    'phoneNumber': 'telefonNumarası',
    'userMailbox': 'kullanıcıPostaKutusu',
    'changePassword': 'değiştirŞifre',
    'oldPassword': 'eskiŞifre',
    'newPassword': 'yeniŞifre',
    'confirmNewPasswordLabel': 'doğrulaYeniŞifreEtiketi',
    'editAvatar': 'düzenleAvatar',
    'username': 'kullanıcı adı',
    'callPhoneNumber': 'araTelefonNumara',
    'loginTime': 'girişZamanı',
    'Please enter a nickname': 'Lütfen bir takma ad girin',
    'Please enter email': 'Lütfen e-posta girin',
    'Please enter a valid email address': 'Lütfen geçerli bir e-posta adresi girin',
    'Please enter your phone number': 'Lütfen telefon numaranızı girin',
    'Please enter a valid phone number': 'Lütfen geçerli bir telefon numarası girin',
    'modify successfully': 'başarıyla değiştirin',
    'fail to modify': 'değiştirme başarısız',
    'Please enter your old password': 'Lütfen eski şifrenizi girin',
    'Please enter your new password': 'Lütfen yeni şifrenizi girin',
    'The password must contain at least 6 characters': 'Şifre en az 6 karakter içermelidir',
    'Please confirm the new password': 'Lütfen yeni şifreyi onaylayın',
    'The two new passwords are different': 'İki yeni şifre farklı',
    'Password changed successfully': 'Şifre başarıyla değiştirildi',
    'essential information': 'temel bilgiler',
    'Failed to change the password': 'Şifre değiştirilemedi',
    'User nickname': 'Kullanıcı takma adı',
    'Subscriber\'s mobile phone number': 'Abonenin cep telefonu numarası',
    'User mailbox': 'Kullanıcı posta kutusu',
    'change password': 'şifreyi değiştir',
    'old password': 'eski şifre',
    'new password': 'yeni şifre',
    'Confirm new password': 'Yeni şifreyi onayla',
    'Edit avatar': 'Avatar düzenle',
    'cell phone number': 'cep telefonu numarası',
    'log-in time': 'giriş zamanı',
    'myAPP': 'Uygulamalarım',
    'verificationCode':'doğrulama Kodu',
    'enterVerificationCode': 'Lütfen bir doğrulama kodu girin',
    'bindPhoneNumber': 'Cep telefonu numaranızı bağlayın',
    'updatePhoneNumber': 'Telefon numaranızı güncelleyin',
    'update':'güncelleştirmek',
    'close':'Kapat',
    'open': 'Açık',
    'applicationName': 'Uygulamanın adı',
    'getCode': 'Doğrulama kodu alın',
    'key':'Anahtar',
    'status': 'devlet',
    'sureChange': 'Bunu değiştireceğinizden emin misiniz?'
  },
  message: {
    'messageTip': 'mesajİpucu',
    'noNewsYet': 'yokHaberHenüz',
    'markedRead': 'işaretlendiOkundu',
    'notificationMessage': 'bildirimMesajı',
    'allRead': 'tümüOkundu',
    'markRead': 'işaretleOkundu',
    'read': 'okundu',
    'message': 'mesaj',
    'No news yet': 'Henüz haber yok',
    'Marked read': 'Okundu olarak işaretlendi',
    'notification message': 'bildirim mesajı',
    'All read': 'Hepsi okundu',
    'Mark read': 'Okundu olarak işaretle'
  },
  base: {
    'navigation': 'navigasyon',
    'own': 'kendi',
    'help': 'yardım',
    'helpDesc': 'yardımMasası',
    'softwareSupport': 'yazılımDesteği',
    'hardwareSupport': 'donanımDesteği',
    'essentialInformation': 'temelBilgiler',
    'Navigation': 'Navigasyon',
    'Personal Center': 'Kişisel Merkez',
    'Do you need any help?': 'Yardıma ihtiyacınız var mı?',
    'We can provide you with the following assistance.': 'Size aşağıdaki yardımı sağlayabiliriz.',
    'IoT technology support': 'IoT teknoloji desteği',
    'Equipment technical support': 'Ekipman teknik desteği',
    'essential information': 'temel bilgiler'
  },
  routesMenu: {
    'homePage': 'anasayfa',
    'data': 'veri',
    'device': 'cihaz',
    'alarm': 'alarm',
    'inform': 'bilgilendir',
    'notification': 'bildirim',
    'arrange': 'düzenle',
    'me': 'Kişisel Merkez',
    'message': 'mesaj',
    'Home Page': 'Ana Sayfa',
    'Data center': 'Veri merkezi',
    'Equipment Center': 'Ekipman Merkezi',
    'Alarm Center': 'Alarm Merkezi',
    'Alarm Inform': 'Alarm Bilgilendirme',
    'Notification channel': 'Bildirim kanalı',
    'Equipment arrangement': 'Ekipman düzenlemesi',
    'Personal Information': 'Kişisel Bilgiler',
    'Message Center': 'Mesaj Merkezi'
  },
  login: {
    'userTerms': 'Kullanım Şartları',
    'iAgree': 'Kabul Ediyorum',
    'captchaSuccess': 'captchaBaşarılı',
    'rememberMe': 'BeniHatırla',
    'captchaFail': 'captchaBaşarısız',
    'signIn': 'OturumAç',
    'welcome': 'Hoş geldin',
    'company': 'Handan Yunnong Akıllı Tarım Teknolojisi Co, Ltd',
    'yantaiCompany': 'Handan Yantai İthalat ve İhracat A.Ş.',
    'companyProfile': '<p class="text-white position-relative">\n' +
      '                  Ürünlerimiz güneş ışığı, hava, toprak ve su ortamı alanlarını kapsamakta, müşterilere hizmet vermek için kablosuz iletişim teknolojisini ve uygun mobil çalışmayı kullanmaktadır. Yüz binlerce sensör sağlıyoruz ve sektörde tanınmış bir sensör ürünleri ve dijital çözümler tedarikçisiyiz.\n' +
      '                </p>\n' +
      '                <p class="text-white position-relative">\n' +
      '                  Şirket, \'bütünlük, entegrasyon, yenilikçilik ve paylaşım\' kültürel kavramına bağlı kalmaktadır ve yukarı ve aşağı müşterilerle \'Dijital Çin\' yeni çağ geliştirme konseptinin gerçekleştirilmesine katkıda bulunmaya ve güvenilir bir izleme ağı sağlamaya isteklidir ve insanın hayatta kalmasının bağlı olduğu çevre için sürdürülebilirlik garantisi!\n' +
      '                </p>',
    'yantaiCompanyProfile': '<p class="text-white position-relative">\n' + 'Handan Yantai İthalat ve İhracat A.Ş.' + '</p>\n' +
      '<p class="text-white position-relative">\n' + 'Ürünlerimiz güneş ışığı, hava, toprak ve su ortamı alanlarını kapsar, müşterilere hizmet etmek için kablosuz iletişim teknolojisi ve kullanışlı mobil operasyondan yararlanır. Yüz binlerce sensör sağlıyoruz ve sektörde sensör ürünleri ve dijital çözümler konusunda tanınmış bir tedarikçiyiz.' + '</p>\n' +
      '<p class="text-white position-relative">\n' + 'Şirket "dürüstlük, entegrasyon, yenilikçilik ve paylaşım" kültürel kavramına bağlı kalmaktadır ve "Dijital Dünya"nın yeni dönem geliştirme kavramının yukarı ve aşağı akış müşterileriyle gerçekleştirilmesine katkıda bulunmaya ve insan yaşamının bağlı olduğu çevre için güvenilir bir izleme ağı ve sürdürülebilirlik garantisi sağlamaya isteklidir!' + '</p>\n',
    'captcha.success': 'captcha.success',
    'Remember me': 'Beni hatırla',
    'captcha.fail': 'captcha.fail',
    'Sign in': 'Oturum aç',
    'Welcome to the Fields on the Cloud (IoT) Platform': 'Buluttaki Tarlalara (IoT) Hoş Geldiniz Platformu',
    'Handan Yunnong Intelligent Agricultural Technology Co., Ltd': 'Yıldız Led Aydınlatma Teknolojileri Toprak San. ve Tic. Ltd. Şti.'
  },
  site: {
    'yantaiTitle':'yantai',
    'primaryName': 'birincilAd',
    'name': 'ad',
    'Fields on the Cloud': 'Buluttaki Alanlar',
    'Fields on the Cloud (IoT) Platform': 'Buluttaki Alanlar (IoT) Platformu'
  },
  navbar: {
    'businessCaseName': 'işDurumuAdı',
    'businessCaseUrl': 'işDurumuUrl',
    'businessConsultingName': 'işDanışmanAdı',
    'businessConsultingUrl': 'işDanışmanUrl',
    'aboutUsName': 'hakkımızdaAd',
    'aboutUsNameUrl': 'hakkımızdaUrl',
    'productCenterName': 'ürünMerkeziAdı',
    'productCenterNameUrl': 'ürünMerkeziAdıUrl',
    'Business Case': 'İş Durumu',
    'http://nong-iot.cn/business-case.html': 'http://nong-iot.cn/business-case.html',
    'Business Consulting': 'İş Danışmanlığı',
    'http://nong-iot.cn/consult.html': 'http://nong-iot.cn/consult.html',
    'About Us': 'Hakkımızda',
    'http://nong-iot.cn/about-us.html': 'http://nong-iot.cn/about-us.html',
    'Product Center': 'Ürün Merkezi',
    'http://nong-iot.cn/': 'http://nong-iot.cn/'
  },
  configurator: {
    'theme': 'tema',
    'themeOptions': 'temaSeçenekleri',
    'sidebarColors': 'kenarçubuğuRenkleri',
    'sidenavType': 'sidenavTürü',
    'sidenavDesc': 'sidenavDesc',
    'white': 'beyaz',
    'dark': 'koyu',
    'navbarFixed': 'navbarSabit',
    'themeSwitching': 'temaDeğişkenliği',
    'quit': 'çıkış',
    'Theme configuration': 'Tema yapılandırması',
    'View the theme options we support.': 'Desteklediğimiz tema seçeneklerini görüntüleyin.',
    'Sidebar color': 'Kenar çubuğu rengi',
    'Left navigation bar': 'Sol gezinme çubuğu',
    'Mode switching supports both light and dark modes': 'Mod değiştirme hem açık hem de koyu modları destekler',
    'White': 'Beyaz',
    'Dark': 'Koyu',
    'Navbar Fixed': 'Navbar Sabit',
    'Light / Dark': 'Açık / Koyu',
    'Exit': 'Çıkış'
  },
  element: {
    '空气温度': 'Hava Sıcaklığı',
    '空气湿度': 'Hava Nemi',
    '大气压强': 'Atmosferik Basınç',
    '风速': 'Rüzgar Hızı',
    '风向': 'Rüzgar Yönü',
    '降雨量': 'Yağış',
    '蒸发量': 'Buharlaşma',
    '土壤温度': 'Toprak Sıcaklığı',
    '土壤湿度': 'Toprak Nemi',
    '土壤EC': 'Toprak EC',
    '土壤EC2': 'Toprak EC2',
    '土壤EC3': 'Toprak EC3',
    '土壤PH': 'Toprak PH',
    '光照强度': 'Işık Yoğunluğu',
    '光合有效': 'Fotosentetik Olarak Aktif Radyasyon',
    '总辐射': 'Toplam Radyasyon',
    '总辐射累积量': 'Kümülatif Toplam Radyasyon',
    '水平辐射': 'Yatay Radyasyon',
    '水平辐射累积量': 'Kümülatif Yatay Radyasyon',
    '斜面辐射': 'Eğim Radyasyonu',
    '斜面辐射累积量': 'Kümülatif Eğim Radyasyonu',
    '散射辐射': 'Dağılı Radyasyon',
    '散射辐射累积量': 'Kümülatif Dağınık Radyasyon',
    '直接辐射': 'Doğrudan Radyasyon',
    '直接辐射累积量': 'Kümülatif Doğrudan Radyasyon',
    '紫外指数': 'UV İndeksi',
    '紫外辐射': 'Ultraviyole Radyasyon',
    '日照时数': 'Güneş Işığı Süresi',
    '噪声': 'Gürültü',
    'PM2.5': 'PM2.5',
    'PM10': 'PM10',
    'CO2': 'CO2',
    'SO2': 'SO2',
    'CO': 'CO',
    'O3': 'O3',
    'H2S': 'H2S',
    'NO2-1': 'NO2-1',
    'NO2-2': 'NO2-2',
    '叶面温度': 'Yaprak Sıcaklığı',
    '叶面湿度': 'Yaprak Nemi',
    '组件温度': 'Modül Sıcaklığı',
    '露点温度': 'Çiğ Noktası Sıcaklığı',
    '小时雨量': 'Saatlik Yağış',
    '24小时雨量': '24 Saatlik Yağış',
    '连续雨量': 'Sürekli Yağış',
    '水温': 'Su Sıcaklığı',
    '水PH': 'Su PH',
    '水EC': 'Su EC',
    '溶氧': 'Çözünmüş Oksijen',
    '浊度': 'Bulanıklık',
    'NH3': 'Amonyak',
    '暴晒温度': 'Maruz Kalma Sıcaklığı',
    '微气象风速': 'Mikroiklim Rüzgar Hızı',
    '微气象风向': 'Mikroiklim Rüzgar Yönü',
    '设备电压': 'Cihaz Voltajı',
    '设备电量': 'Cihaz Gücü',
    'TSP(PM)100': 'TSP (PM100)',
    '负氧离子': 'Negatif Oksijen İyonları',
    '流速(多普勒)': 'Akış Hızı (Doppler)',
    '液位(超声)': 'Sıvı Seviyesi (Ultrasonik)',
    '液位(压力)': 'Sıvı Seviyesi (Basınç)',
    '能见度': 'Görünürlük',
    '路面状况路面温度': 'Yol Yüzey Sıcaklığı',
    '路面状况积水深度': 'Yol Yüzey Su Derinliği',
    '路面状况冰厚度': 'Yol Yüzey Buz Kalınlığı',
    '路面状况雪厚度': 'Yol Yüzey Kar Kalınlığı',
    '路面状况湿滑系数': 'Yol Yüzey Kayganlık Katsayısı',
    '路面状况路面状态': 'Yol Yüzey Durumu',
    '冰点': 'donma noktası',
    '盐溶解度': 'Tuz çözünürlüğü',
    'GPS东西经': 'GPS Boylamı (Doğu-Batı)',
    'GPS经度': 'GPS Boylamı',
    'GPS南北纬': 'GPS Enlemi (Kuzey-Güney)',
    'GPS纬度': 'GPS Enlemi',
    'TVOC': 'TVOC',
    '雨雪报警': 'Yağmur/Kar Alarmı',
    '电池电压': 'Pil Voltajı',
    '太阳能电压': 'Güneş Voltajı',
    '信号强度': 'Sinyal Gücü',
    '果实膨大': 'Meyve Genişlemesi',
    '氨氮': 'Amonyak Azot',
    '水膜厚度': 'Su Filmi Kalınlığı',
    '土壤硬度': 'Toprak Sertliği',
    '蒸腾量': 'Terleme',
    'EC': 'EC',
    '前置冲洗时间': 'Ön Yıkama Süresi',
    '轮灌间隔': 'Sulama Aralığı',
    '轮灌次数': 'Sulama Sayısı',
    '水肥机工作模式': 'Gübre Makinesi Modu',
    '水肥机状态': 'Gübre Makinesi Durumu',
    '水泵状态': 'Su Pompası Durumu',
    'PH': 'PH',
    '肥泵状态': 'Gübre Pompası Durumu',
    '目标EC': 'Hedef EC',
    '目标PH': 'Hedef PH',
    '后置冲洗时间': 'Son Yıkama Süresi',
    '主水源瞬时流量': 'Ana Su Kaynağı Anlık Akış',
    '主水源累积流量': 'Ana Su Kaynağı Toplam Akış'
  }
};
